module.exports = __webpack_public_path__ + "img/visa.1d10a8cf.png";